module.exports = __webpack_public_path__ + "static/img/n-type.71d42615.png";